var map = {
	"./button/styles.scss": "U5iq",
	"./card/styles.scss": "UruQ",
	"./carousel/styles.scss": "e1qj",
	"./circular-image-mask/styles.scss": "qKPk",
	"./contents-list/styles.scss": "0u0z",
	"./country-nav/styles.scss": "QuiE",
	"./country-readmore/styles.scss": "SZeN",
	"./disclosure-panel/styles.scss": "q+iD",
	"./expert-quote/styles.scss": "fTzr",
	"./feedback-button/styles.scss": "9OGm",
	"./footer/styles.scss": "xlo0",
	"./footnotes/styles.scss": "EJo5",
	"./header/styles.scss": "FgRV",
	"./homepage-animation/styles.scss": "La93",
	"./icon-button/styles.scss": "OhL3",
	"./icons/styles.scss": "A9TQ",
	"./loader/styles.scss": "IvY0",
	"./page-header/styles.scss": "z1jo",
	"./policy-bar/styles.scss": "YBUQ",
	"./policy-button/styles.scss": "4kTu",
	"./policy-nav/styles.scss": "gTnK",
	"./policy-next-previous/styles.scss": "0xTa",
	"./policy-sidebar/styles.scss": "id7u",
	"./policy-title/styles.scss": "gIrS",
	"./quote-block/styles.scss": "ftVV",
	"./score-bar/styles.scss": "3rF6",
	"./score-label/styles.scss": "EJzu",
	"./score-table/styles.scss": "tWA6",
	"./section/styles.scss": "yMf5",
	"./share-buttons/styles.scss": "1Vb4",
	"./sidebar/styles.scss": "VYbO",
	"./text-link/styles.scss": "3DaQ",
	"./theme-stack/styles.scss": "Pllf",
	"./title-bar/styles.scss": "j7+K",
	"./translate-button/style.scss": "lYqK",
	"./translate-dropdown/styles.scss": "n8cK",
	"./wheel-key/styles.scss": "me7U"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "skLc";